import { IPerformer } from '@interfaces/performer';
import dynamic from 'next/dynamic';

const ScrollListPerformerFeed = dynamic(() => (import('@components/post/list/scroll-list')));
const FilterContentsBar = dynamic(() => (import('./search-bar')));

type Props = {
  performer: IPerformer;
  setTotal: Function;
  total: number;
};

export default function PostTab({
  performer, setTotal, total
}: Props) {
  return (
    <>
      <FilterContentsBar tab="post" />
      <ScrollListPerformerFeed
        query={{
          performerId: performer._id
        }}
        total={total}
        getTotal={(t) => setTotal(t)}
      />
    </>
  );
}
